import DocumentsInterface from '../../../interfaces/DocumentsInterface';
import { DocumentsStateManager } from './DocumentsStateManager';
import Documents from '../../../services/Documents';

export interface CardProps {
  card: DocumentsInterface;
  moveCard: (dragIndex: number, hoverIndex: number, idFolder: string) => void;
  documentsState: DocumentsStateManager;
  index: number;
}

export interface DragItem {
  index: number;
  id: string;
  type: string;
}

export type HoverDivInfo = {
  visible: boolean;
  x: number;
  y: number;
  width: number;
  height: number;
};

export const redirectToPdf = async (id: string, documentsState: DocumentsStateManager) => {
  documentsState.setLoading(true);
  const pdf = await Documents(documentsState.state.token || '').pdf(id);
  const binaryString = atob(pdf.data);

  // Convert binary string to Uint8Array
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  // Create blob and open in new tab
  const blob = new Blob([bytes], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl, '_blank');
  documentsState.setLoading(false);
};

export const hoverPanel = (card: DocumentsInterface, hoverDiv: HoverDivInfo) => {
  return (
    <div
      className={'hover-panel'}
      style={{
        // transform: `translate(${hoverDiv.x}px, ${hoverDiv.y}px)`,
        position: 'absolute',
        width: hoverDiv.width,
        height: hoverDiv.height,
        top: hoverDiv.y + 10,
        left: hoverDiv.x,
      }}
    >
      <table>
        {card.fileName && (
          <tr>
            <td style={{ fontSize: 'small' }}>Filename:</td>
            <td style={{ fontSize: 'small' }}>{card.fileName}</td>
          </tr>
        )}
        {card.author && (
          <tr>
            <td style={{ fontSize: 'small' }}>Author:</td>
            <td style={{ fontSize: 'small' }}>{card.author}</td>
          </tr>
        )}
        {card.subject && (
          <tr>
            <td style={{ fontSize: 'small' }}>Subject:</td>
            <td style={{ fontSize: 'small' }}>{card.subject}</td>
          </tr>
        )}
        {card.creator && (
          <tr>
            <td style={{ fontSize: 'small' }}>Creator:</td>
            <td style={{ fontSize: 'small' }}>{card.creator}</td>
          </tr>
        )}
        {card.keywords && (
          <tr>
            <td style={{ fontSize: 'small' }}>Keywords:</td>
            <td style={{ fontSize: 'small' }}>{card.keywords}</td>
          </tr>
        )}
        {card.producer && (
          <tr>
            <td style={{ fontSize: 'small' }}>Producer:</td>
            <td style={{ fontSize: 'small' }}>{card.producer}</td>
          </tr>
        )}
        {card.pdfCreationDate && (
          <tr>
            <td style={{ fontSize: 'small' }}>Creation:</td>
            <td style={{ fontSize: 'small' }}>{card.pdfCreationDate}</td>
          </tr>
        )}
        {card.pdfModificationDate && (
          <tr>
            <td style={{ fontSize: 'small' }}>Modification:</td>
            <td style={{ fontSize: 'small' }}>{card.pdfModificationDate}</td>
          </tr>
        )}
      </table>
    </div>
  );
};

export const cardHoverHeight = (card: DocumentsInterface) => {
  const propertiesToCheck = [
    'fileName',
    'author',
    'subject',
    'creator',
    'keywords',
    'producer',
    'pdfCreationDate',
    'pdfModificationDate',
  ];

  const totalItems = propertiesToCheck.filter((prop) => Boolean(card[prop as keyof DocumentsInterface])).length;

  return totalItems * 30;
};
